export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8339.c697f27b.jpg";